export const getIriData = (iri: string) => {
  const [entity, id] = iri.split('/').filter(Boolean).slice(1);

  return { entity, id: parseInt(id, 10) };
};

// needs to be replaced
export const isIriString = (value: string | number | null): value is string => {
  return typeof value === 'string' && value.includes('api/');
};

// Filter keys whose wire format is the full IRI, not the bare numeric id -
// typically polymorphic relations (e.g. Log's 'about', Rating's 'target')
// where the entity type getIriData() would otherwise discard is load-bearing.
// Keyed by filter key rather than recorded per-instance so it also applies to
// ISimpleFilter[] rehydrated from persisted ConfigPresets/UserConfigs saved
// before this registry existed.
export const IRI_FILTER_KEYS = new Set<string>([
  'about',
  'related',
  'target',
  'reasonObject',
]);
